module.exports = __webpack_public_path__ + "img/logo-21.1aff94f.jpg";